import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toJsArray19cldvndk6qr4 as toJsArray,
  toByteArray18j13y992cujz as toByteArray,
} from './TargetUtilsJs.mjs';
import { toHexString5bhtjxqec7ow as toHexString } from '../../../../kotlin-kotlin-stdlib/kotlin/text/HexExtensions.mjs';
import { substringiqarkczpya5m as substring } from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get__crypto() {
  _init_properties_Crypto_web_kt__nxveo7();
  return _crypto;
}
var _crypto;
var md5Shifts;
var md5T;
function generateNonceBlocking(length) {
  length = length === VOID ? 32 : length;
  _init_properties_Crypto_web_kt__nxveo7();
  var buffer = toJsArray(new Int8Array((length / 2 | 0) + 1 | 0));
  get__crypto().getRandomValues(buffer);
  return substring(toHexString(toByteArray(buffer)), 0, length);
}
var properties_initialized_Crypto_web_kt_8s9a0n;
function _init_properties_Crypto_web_kt__nxveo7() {
  if (!properties_initialized_Crypto_web_kt_8s9a0n) {
    properties_initialized_Crypto_web_kt_8s9a0n = true;
    _crypto = globalThis ? globalThis.crypto : window.crypto || window.msCrypto;
    // Inline function 'kotlin.intArrayOf' call
    md5Shifts = new Int32Array([7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21]);
    // Inline function 'kotlin.intArrayOf' call
    md5T = new Int32Array([-680876936, -389564586, 606105819, -1044525330, -176418897, 1200080426, -1473231341, -45705983, 1770035416, -1958414417, -42063, -1990404162, 1804603682, -40341101, -1502002290, 1236535329, -165796510, -1069501632, 643717713, -373897302, -701558691, 38016083, -660478335, -405537848, 568446438, -1019803690, -187363961, 1163531501, -1444681467, -51403784, 1735328473, -1926607734, -378558, -2022574463, 1839030562, -35309556, -1530992060, 1272893353, -155497632, -1094730640, 681279174, -358537222, -722521979, 76029189, -640364487, -421815835, 530742520, -995338651, -198630844, 1126891415, -1416354905, -57434055, 1700485571, -1894986606, -1051523, -2054922799, 1873313359, -30611744, -1560198380, 1309151649, -145523070, -1120210379, 718787259, -343485551]);
  }
}
//region block: exports
export {
  generateNonceBlocking as generateNonceBlockingbv5f4wo6otfs,
};
//endregion

//# sourceMappingURL=Crypto.web.mjs.map
